var generateStyle = function generateStyle(componentTheme) {
  return {
    groupWrapper: {
      padding: '0',
      width: 'calc(25% + 350px)',
      minWidth: componentTheme.cardMinWidth,
      maxWidth: '100%'
    },
    bodyContainer: {
      overflow: 'auto',
      maxHeight: '600px'
    }
  };
};
export default generateStyle;